import { useState } from 'react';
import { Title, Overview, Content } from '@/containers/myInvest';
import { RefreshProvider } from '@/components/providers/refresh';
import { CoinInfoProvider } from '@/components/providers/coinInfo';
import { GetStaticProps, GetStaticPaths } from 'next';
import { ALL_LOCALES } from '@web3/base-utils';
import { getMessage } from '@web3/base-lang';
import styles from './index.module.scss';

export const MyInvest = () => {
  const [showAsset, setShowAsset] = useState(true);

  return (
    <div className={styles.container}>
      <RefreshProvider>
        <Title
          showAsset={showAsset}
          onChangeShowAsset={(v) => setShowAsset(v)}
        />
        <Overview showAsset={showAsset} />
        <div className={styles.splitLine} />
        <CoinInfoProvider>
          <Content />
        </CoinInfoProvider>
      </RefreshProvider>
    </div>
  );
};

export const getStaticProps: GetStaticProps = async (context) => {
  const { locale } = context.params as any;

  const messages = await getMessage(
    'web3-staking',
    {
      locale,
      entry: import.meta.url,
      additions: ['stakingSeoTitle', 'seoKeyword', 'stakingSeoDesc'],
    },
    false
  );

  return {
    props: {
      locale,
      messages,
    },
  };
};

export const getStaticPaths: GetStaticPaths = async () => {
  return {
    paths: ALL_LOCALES.map((locale) => ({
      params: {
        locale: locale.value,
      },
    })),
    fallback: true,
  };
};

export default MyInvest;
